/**
 * BOS+ expansion (additive) — plus launcher nav manifest.
 *
 * Append-only. Each later phase adds ONE entry so its module is reachable from
 * the `/plus` launcher (and so e2e can navigate to it by `data-testid`):
 *
 *   { key: 'recruiting', label: 'Recruiting', path: '/recruiting',
 *     testid: 'plus-nav-recruiting' }
 *
 * `path` is the route the module registers in PlusRoutes.jsx. `testid` is the
 * stable hook the launcher link renders. Never reorder existing entries.
 */

const plusNav = [
  // ===== plus modules (append `{ key, label, path, testid }` below) =====
  { key: 'recruiting', label: 'Recruiting (ATS)', path: '/recruiting', testid: 'plus-nav-recruiting' },
  { key: 'onboarding', label: 'Onboarding & Journeys', path: '/recruiting/onboarding', testid: 'plus-nav-onboarding' },
  { key: 'compensation', label: 'Compensation', path: '/compensation', testid: 'plus-nav-compensation' },
  { key: 'benefits', label: 'Benefits', path: '/benefits', testid: 'plus-nav-benefits' },
  { key: 'talent', label: 'Talent & Skills', path: '/talent', testid: 'plus-nav-talent' },
  { key: 'learning', label: 'Learning (LMS)', path: '/learning', testid: 'plus-nav-learning' },
  { key: 'time', label: 'Time Tracking', path: '/time', testid: 'plus-nav-time' },
  { key: 'absence', label: 'Absence & Accruals', path: '/absence', testid: 'plus-nav-absence' },
  { key: 'payroll-global', label: 'Global Payroll', path: '/payroll-global', testid: 'plus-nav-payroll-global' },
  { key: 'expenses', label: 'Expenses', path: '/expenses', testid: 'plus-nav-expenses' },
  { key: 'entities', label: 'Legal Entities', path: '/entities', testid: 'plus-nav-entities' },
  { key: 'revrec', label: 'Revenue Recognition', path: '/revrec', testid: 'plus-nav-revrec' },
  { key: 'planning', label: 'Planning / FP&A', path: '/planning', testid: 'plus-nav-planning' },
  { key: 'vms',      label: 'Vendor Management',  path: '/vms',      testid: 'plus-nav-vms' },
  { key: 'sourcing', label: 'Sourcing / RFx',      path: '/sourcing', testid: 'plus-nav-sourcing' },
  { key: 'bp',       label: 'Business Processes', path: '/bp',                testid: 'plus-nav-bp' },
  { key: 'security', label: 'Security Policies',   path: '/security-policies', testid: 'plus-nav-security' },
  { key: 'prism',        label: 'Prism Analytics', path: '/prism',        testid: 'plus-nav-prism' },
  { key: 'intelligence', label: 'Intelligence',    path: '/intelligence', testid: 'plus-nav-intelligence' },
  { key: 'messenger', label: 'Messenger', path: '/messenger', testid: 'plus-nav-messenger' },
];

export default plusNav;
